import styled from 'styled-components'
import { BREAKPOINTS, COLOR_DARK_BLUE, COLOR_WHITE, COLOR_BLUE } from './tokens'

type HeadingProps = {
    white?: boolean
}

export const Heading = styled.h2<HeadingProps>`
    margin-top: 0;
    margin-bottom: 8px;

    font-family: Bryant, sans-serif;
    font-size: 26px;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 0.33px;
    ${props => (props.white ? COLOR_WHITE : COLOR_DARK_BLUE)};
`

export const StaticContentHeading = styled.h2<HeadingProps>`
    margin: 0;
    font-family: Bryant, sans-serif;

    font-size: 22px;
    font-weight: bold;
    letter-spacing: -1.38px;

    line-height: 32px;
    color: ${COLOR_DARK_BLUE};
    text-align: center;

    @media (min-width: ${BREAKPOINTS.tablet}px) {
        font-size: 32px;
        line-height: 52px;
        letter-spacing: -1.66px;
        text-align: left;
    }
`

export const SidebarHeading = styled.h2`
    margin-top: 0;
    margin-bottom: 8px;

    font-family: Bryant, sans-serif;
    font-size: 16px;
    line-height: 1.35;
    letter-spacing: -0.35px;
    text-transform: uppercase;
    color: ${COLOR_DARK_BLUE};
`

type SubHeadingProps = {
    noMargin?: boolean
}

export const SubHeading = styled.h3<SubHeadingProps>`
    margin: ${props => (props.noMargin ? 0 : null)};
    font-family: Bryant, sans-serif;
    font-weight: normal;
    color: ${COLOR_DARK_BLUE};
`

export const HeroHeading = styled.h1`
    margin: 0;
    font-family: Bryant, sans-serif;

    font-size: 28px;
    font-weight: normal;
    letter-spacing: -1.38px;

    line-height: 32px;
    color: ${COLOR_DARK_BLUE};
`

export const HeroStaticHeading = styled.h1`
    margin: 0;
    font-family: Bryant, sans-serif;

    font-size: 28px;
    font-weight: normal;
    letter-spacing: -1.38px;

    line-height: 32px;
    color: ${COLOR_DARK_BLUE};

    @media (min-width: ${BREAKPOINTS.tablet}px) {
        font-size: 47px;

        line-height: 52px;
        letter-spacing: -1.66px;
    }
`

export const HeroStaticSecondHeading = styled.h2`
    margin: 0;
    font-family: Bryant, sans-serif;
    font-weight: bold;
    font-size: 16px;
    line-height: 1.35;
    letter-spacing: -0.35px;
    text-transform: uppercase;

    color: ${COLOR_DARK_BLUE};

    @media (min-width: ${BREAKPOINTS.tablet}px) {
        font-size: 28px;
        font-weight: normal;
        letter-spacing: -1.38px;
        line-height: 32px;
        text-transform: none;
    }
`

type TeaserTitleProps = {
    white?: boolean
    small?: boolean
}

export const TeaserTitle = styled.span<TeaserTitleProps>`
    display: block;
    margin: 0;
    font-family: Bryant, sans-serif;
    font-size: ${props => (props.small ? '18px' : '22px')};
    line-height: 24px;
    letter-spacing: -0.68px;
    font-weight: bold;
    color: ${props => (props.white ? COLOR_WHITE : COLOR_BLUE)};

    &:hover {
        color: ${props => (props.white ? COLOR_WHITE : COLOR_DARK_BLUE)};
        text-decoration: none;
    }
`

export const EventTeaserTitle = styled.span`
    display: block;
    margin: 0;
    font-family: Bryant, sans-serif;
    font-size: 24px;
    line-height: 26px;
    letter-spacing: -0.68px;
    font-weight: bold;
    color: ${COLOR_BLUE};
    margin-bottom: 8px;

    &:hover {
        color: ${COLOR_DARK_BLUE};
        text-decoration: none;
    }
`
